<ng-container *ngIf="loading">
  <app-data-loading></app-data-loading>
</ng-container>

<ng-container *ngIf="!loading">
  <app-page-title title="Partages et Accès"></app-page-title>
  <div class="container-fluid">
    <div *ngIf="myRequests.length > 0" class="share-part">
      <h3>Mes demandes d'accès</h3>
      <div>
        <app-share-request-table [requests]="myRequests"></app-share-request-table>
      </div>
    </div>
    <div class="share-part">
      <h3>Mes partages</h3>
      <p class="desc">Retouvez ici tous les partages que vous avez effectués sur vos propriétés</p>
      <div *ngIf="myShares.length > 0; else noShare">
        <app-share-table [shares]="myShares" [ownedProperties]="myRealProperties" [modeMyShares]="true"
          [showAddButton]="true" (sharesUpdated)="loadData()"></app-share-table>
      </div>
      <ng-template #noShare>
        <span class="no-content">Aucun partage n'a encore été effectué sur vos bien.</span>
      </ng-template>
    </div>
    <div class="share-part">
      <h3>Mes accès</h3>
      <p class="desc">Retouvez ici tous les accès dont vous disposez sur d'autres propriétés</p>
      <div *ngIf="myAccesses.length > 0; else noAccess">
        <app-share-table [shares]="myAccesses" [modeMyShares]="false" (sharesUpdated)="loadData()"></app-share-table>
      </div>
      <ng-template #noAccess>
        <span class="no-content">Aucun bien ne vous a encore été partagé.</span>
      </ng-template>
    </div>
  </div>
</ng-container>